import React, { Fragment } from 'react';

import { getSinglarOrPluralWord, sortTickets, formatNumber } from '../../../utilities/helpers';

import Form from 'react-bootstrap/Form';
import Stack from 'react-bootstrap/Stack';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';

export default function DisplayTickets({ role, status, tickets, selectedTickets, setSelectedTickets, isScalper, groupAndSortBySectionRow }) {

    const handleChange = (val) => setSelectedTickets(val);

    const handleCheck = e => {
        const { id, value, checked } = e.target;
        console.log('check', id, value);

        const [secRow, seatId] = id?.split('--')
        console.log(secRow, seatId);

        // Find the full ticket object by seatId
        const ticket = tickets.get(secRow)?.tickets?.find(t => t.seatId === seatId);
        console.log(ticket);

        setSelectedTickets([...selectedTickets, ticket]);
        if (!checked) {
            setSelectedTickets(selectedTickets.filter((item) => item?.seatId !== seatId));
        }
    };

    const handleSelectAll = (e) => {
        const { checked, id } = e.target;
        console.log('select all', checked, id, tickets.get(id));

        let ticketsToAdd = tickets.get(id)?.tickets
        console.log(ticketsToAdd);
        if (checked) {
            // if some checkboxes are checked, don't add them to array again
            if (selectedTickets?.length > 0) {
                // filter out tickets that are already checked
                ticketsToAdd = ticketsToAdd.filter(
                    (ticket) => !selectedTickets.some(t => t.seatId === ticket.seatId)
                );
            }
            setSelectedTickets([...selectedTickets, ...ticketsToAdd.map((item) => item)]);
        }
        // not checked - remove all from selectedTickets array
        else {
            setSelectedTickets(
                selectedTickets?.filter(
                    (ticket) => !ticketsToAdd.some(item => item?.seatId === ticket.seatId)
                )
            );
        }
    };

    // check if all checkboxes in category are checked 
    const checker = (tickets) => {
        let isCheckAll = tickets.every(ticket => selectedTickets.some(t => t.seatId === ticket.seatId))

        return isCheckAll
    }

    // tickets should be tickets or selectedTickets depending on role
    tickets = tickets ? (!isScalper ? sortTickets(tickets) : tickets) : selectedTickets;

    const getLabel = (secRow) => {
        // sec - row 
        const [sec, row] = secRow?.split('-')
        if (row !== "null") {
            return `Sec ${sec} \u2022 Row ${row}`;
        } else {
            return `Sec ${sec}`;
        }
    };

    const getSeatLabel = seatNumber => {
        if (seatNumber) {
            return `Seat ${seatNumber}`
        } else {
            return 'GA'
        }
    }

    return (
        <Fragment>
            {role === 'select' && (
                <h6 className="modal-body-heading-title modal-body-heading-title--sm">Select tickets to {status}</h6>
            )}
            {!isScalper && (
                <Stack direction="horizontal" className="split-row">
                    <div>
                        <span className="small small-bold">{tickets[0]?.generalAdmission ? 'General Admission' : `Sec ${tickets[0]?.sectionNumber} \u2022 Row ${tickets[0]?.rowNumber}`}</span>
                    </div>
                    <div className='flex-shrink-0'>
                        <span className="num-tickets">{formatNumber(tickets?.length)} {getSinglarOrPluralWord(tickets?.length)} </span>
                    </div>
                </Stack>
            )}
            {role === 'select' ? (
                <>
                    {!isScalper ? (
                        <ToggleButtonGroup
                            type="checkbox"
                            onChange={handleChange} className="flex-wrap tickets-btn-group">
                            {
                                tickets && tickets.map((ticket, index) => (
                                    <ToggleButton className="ticket-pick" id={`tbg-btn-${index}`} variant="default" value={ticket} key={index}>
                                        {ticket?.generalAdmission ? 'GA' : (
                                            <Stack gap={1}>
                                                <span className='label'>Seat</span>
                                                <span>{ticket?.seatNumber}</span>
                                            </Stack>
                                        )}
                                    </ToggleButton>
                                ))}
                        </ToggleButtonGroup>
                    ) : (
                        <ul className='d-flex d-flex-column gap-3'>
                            {[...(tickets.entries())]?.map(([key, value]) => (
                                <li key={key}>
                                    <Stack direction='horizontal' className='justify-content-between align-items-start'>
                                        <Form.Check
                                            label={`${getLabel(key)} (select all)`}
                                            type="checkbox"
                                            checked={checker(value?.tickets)}
                                            id={key}
                                            name={key}
                                            onChange={handleSelectAll}
                                        />
                                        <span className='num-tickets'>{formatNumber(value?.tickets?.length)} {getSinglarOrPluralWord(value?.tickets?.length)}</span>
                                    </Stack>
                                    <ul className='ps-3'>
                                        {value?.tickets?.map(ticket => (
                                            <li key={ticket?.seatId}>
                                                <Form.Check
                                                    type="checkbox"
                                                    label={`${getSeatLabel(ticket?.seatNumber)}`}
                                                    id={`${key}--${ticket?.seatId}`}
                                                    onChange={handleCheck}
                                                    checked={
                                                        ticket?.seatId
                                                            ? selectedTickets.some(t => t.seatId === ticket.seatId)
                                                            : false
                                                    }
                                                    className='mb-2'
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            ))}
                        </ul>
                    )}
                </>
            ) : (
                <>
                    {!isScalper ? (
                        <Stack direction="horizontal" className="btn-group tickets-btn-group flex-wrap">
                            {selectedTickets && sortTickets(selectedTickets).map((ticket, index) => (
                                <div className="btn ticket-pick selected" key={index}>
                                    {ticket?.generalAdmission ? 'GA' : (
                                        <Stack gap={1}>
                                            <span className='label'>Seat</span>
                                            <span>{ticket?.seatNumber}</span>
                                        </Stack>
                                    )}
                                </div>
                            ))}
                        </Stack>
                    ) : (
                        <ul className='fw-medium d-flex d-flex-column gap-3'>
                            {[...(groupAndSortBySectionRow(selectedTickets).entries())]?.map(([key, value]) => (
                                <li key={key} className='d-flex d-flex-column gap-2'>
                                    <Stack direction='horizontal' className='justify-content-between align-items-start'>
                                        <span className='small'>{getLabel(key)}</span>
                                        <span className='num-tickets'>{formatNumber(value?.tickets?.length)} {getSinglarOrPluralWord(value?.tickets?.length)}</span>
                                    </Stack>
                                    <ul className='ps-3 d-flex d-flex-column gap-1'>
                                        {value?.tickets?.map(ticket => (
                                            <li key={ticket?.seatId} className='small'>{getSeatLabel(ticket?.seatNumber)}</li>
                                        ))}
                                    </ul>
                                </li>
                            ))}
                        </ul>
                    )}
                </>
            )}
        </Fragment>
    );
}